import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchProducts(first = 24) {
  try {
    const { data } = await axios.get(`${API}/shopify/products`, {
      params: { first },
    });
    return data;
  } catch (err) {
    console.error("Failed to fetch products:", err);
    return { products: [], source: "error" };
  }
}

export async function fetchSection(section, first = 12) {
  try {
    const { data } = await axios.get(`${API}/shopify/section/${section}`, {
      params: { first },
      timeout: 30000,
    });
    return data;
  } catch (err) {
    console.error(`Failed to fetch section ${section}:`, err);
    return { products: [], source: "error" };
  }
}

export async function fetchCollection(handle, first = 12) {
  try {
    const { data } = await axios.get(`${API}/shopify/collection/${handle}`, {
      params: { first },
    });
    return data;
  } catch (err) {
    console.error(`Failed to fetch collection ${handle}:`, err);
    return { collection: null, products: [], source: "error" };
  }
}

export async function fetchCollections() {
  try {
    const { data } = await axios.get(`${API}/shopify/collections`);
    return data;
  } catch (err) {
    console.error("Failed to fetch collections:", err);
    return { collections: [], source: "error" };
  }
}

export async function fetchProduct(handle) {
  try {
    const { data } = await axios.get(`${API}/shopify/product/${handle}`);
    return data.product;
  } catch (err) {
    console.error("Failed to fetch product:", err);
    return null;
  }
}

export async function createCart(variantId, quantity = 1) {
  try {
    const { data } = await axios.post(`${API}/shopify/cart`, {
      variantId,
      quantity,
    });
    return data;
  } catch (err) {
    console.error("Failed to create cart:", err);
    return null;
  }
}

export async function addToShopifyCart(cartId, variantId, quantity = 1) {
  try {
    const { data } = await axios.post(
      `${API}/shopify/cart/add?cart_id=${encodeURIComponent(cartId)}`,
      { variantId, quantity }
    );
    return data;
  } catch (err) {
    console.error("Failed to add to cart:", err);
    return null;
  }
}

/**
 * Map a raw Shopify product object to the card format used by the frontend.
 */
export function mapShopifyProduct(p) {
  const tags = (p.tags || []).map((t) => t.toLowerCase());
  let fit = "Fits True to Size";
  if (tags.includes("generous") || tags.includes("generous fit") || tags.includes("runs generous") || tags.includes("runs-generous")) fit = "Runs Generous";
  else if (tags.includes("runs-small") || tags.includes("runs small")) fit = "Runs Small";
  else if (tags.includes("runs-true") || tags.includes("runs true") || tags.includes("true to size")) fit = "Fits True to Size";

  return {
    id: p.id,
    title: p.title,
    handle: p.handle,
    category: (p.productType || "GENERAL").toUpperCase(),
    fit,
    price: parseFloat(p.price),
    currency: p.currency || "USD",
    image: p.images?.[0]?.url || null,
    images: (p.images || []).map((img) => img.url || img).filter(Boolean),
    variants: p.variants || [],
    color: "#FDEAEB",
    isShopify: true,
    variantId: p.variants?.[0]?.id || null,
  };
}
